const PARTNERS = [
  { name: "A.m Market", src: "/partenaires/am-market.jpg", sector: "Commerce & distribution" },
  { name: "ORKYN'", src: "/partenaires/orkyn.png", sector: "Prestataire de santé à domicile" },
  { name: "AM Salon De Beauté", src: "/partenaires/am-salon-beaute.webp", sector: "Salon de beauté" },
  { name: "Garage JT AUTO'S", src: "/partenaires/garage-jt-auto-new.png", sector: "Carrosserie & mécanique" },
];

/**
 * PartnersStrip — bandeau « Ils nous font confiance » affiché sur TOUTES les pages
 * publiques, juste au-dessus du footer (via PublicLayout dans App.js).
 */
export const PartnersStrip = () => {
  return (
    <section
      className="bg-white"
      style={{ paddingTop: 56, paddingBottom: 56, borderTop: "1px solid #E6ECF2" }}
      data-testid="partners-strip"
      aria-label="Nos partenaires"
    >
      <div className="nx-container">
        <p
          className="text-center"
          style={{
            fontFamily: "Exo 2, sans-serif",
            fontWeight: 700,
            fontSize: 13,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#55657A",
            marginBottom: 36,
          }}
        >
          Ils nous font <span style={{ color: "#00B4D8" }}>confiance</span>
        </p>
        <div
          className="flex flex-wrap items-start justify-center"
          style={{ gap: "32px 64px" }}
        >
          {PARTNERS.map((p, i) => (
            <div
              key={p.name}
              className="nx-partner-logo"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                transition: "transform 0.35s ease",
              }}
              data-testid={`partner-logo-${i}`}
            >
              <div
                className="nx-partner-logo-img"
              >
                <img
                  src={p.src}
                  alt={`Logo ${p.name}`}
                  loading="lazy"
                  style={{ maxHeight: 64, maxWidth: 220, objectFit: "contain" }}
                />
              </div>
              <p
                style={{
                  marginTop: 14,
                  marginBottom: 2,
                  fontFamily: "Exo 2, sans-serif",
                  fontWeight: 700,
                  fontSize: 15,
                  color: "#0D2B45",
                }}
              >
                {p.name}
              </p>
              <p style={{ margin: 0, fontSize: 13, color: "#55657A" }}>{p.sector}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersStrip;
